var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.009,
    height: 36.009,
    viewBox: "0 0 36.009 36.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1259 -726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(1259 726)",
    fill: "#dae0e7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1262.725 729.725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.559,
    height: 28.559,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.666 7.291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.218,8.249,0,1.031,1.031,0,7.217,6.186,13.4,0l1.031,1.031L7.217,8.249Z",
    transform: "translate(0 14.436) rotate(-90)",
    fill: "#0d1c4b",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.44573abc08b04b811ae90814f3e82898.svg";
export { ForwardRef as ReactComponent };